// @ts-strict-ignore
import { Component, Input, ViewContainerRef, EventEmitter, Output, ViewChild, ElementRef, OnInit } from '@angular/core';
import { SohoToastService } from 'ids-enterprise-ng';
import { LMFormPanelBase } from './lm-form-panel-base';
import { LMContextService } from '@services/lm-context.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMHtmlUrlDocComponent, LMUrlDocSaveResult } from '@html/lm-html-url-doc.component';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { Observer, Observable } from 'rxjs';
import { LMUrlUtilService } from '@services/utils';
import { LMPanelTransactionEvent } from './services';
import { LMListTransactionEvent } from '@list/lm-list.component';
import { LMActionFormDialogResultCode } from '@modal/lm-action-form-dialog.service';
import { AppConstants } from '@utils/app.constants';
import { LMGlobalUtilService } from '@app/utils';
import { LMRefreshRequest } from '@app/components';

@Component({
  selector: 'lm-form-panel-url',
  template: `
    <lm-html-url-doc #LMHtmlUrlDoc
        *ngIf="activated && fromDataView && !hasError"
        [style.height]="'100%'"
        parentContainerId="{{!testVersion1 ? panelId : null}}"
        [frameIdentifier]="panelId"
        [isHtmlFragment]="true"
        [url]="formattedUrl"
        [bottomSpacing] = "bottomSpacing"
        [isPanelNavigation]="isPanelNavigation"
        [showLoading]="false"
        [placeHolder]="placeHolder"
        [adjustFrameToWindow]="true"
        (landmarkApiLoaded)="onLandmarkApiLoaded($event)"
        (landmarkCustomReady)="onLandmarkCustomReady($event)"
        (notifyUrlTransactionComplete)="onNotifyUrlTransactionComplete($event)"
    ></lm-html-url-doc>
    
    <div *ngIf="activated && hasError">
      <p style="font-size:16pt; text-align: center;margin-top: 30px;">{{errorTitle}}</p>
      <p style="text-align: center;">{{errorMsg}}</p>
    </div>
<!--
    [uniqueId]="ref + 'Iframe'"
    todo ppatton - These functions aren't in the component. - can we just remove?
    (listDisplayed)="onListDisplayed($event)"
    (contentModified)="onContentModified($event)"
-->
  `,
})
export class LMFormPanelUrlComponent implements LMFormPanelBase, OnInit {
  @ViewChild('LMHtmlUrlDoc') htmlDocComponent: LMHtmlUrlDocComponent;

  @Input() placeHolder: ViewContainerRef;

  @Input() set fromDataView(fromDataView) {
    this._fromDataView = fromDataView;
    this.compileURLMessageRule();
  }
  get fromDataView(): LMDataView {
    if (this.needsReload || this.panelDataState === 'stale_needsReload') {

      // -------------------------------------------------------------
      // return null fromDataView so tabs non activated tabs will
      // not load their data data.
      // -------------------------------------------------------------
      return null;
    }

    return this._fromDataView;
  }

  @Input() bottomSpacing = 0;
  @Input() needsReload: boolean;
  @Input() panelDataState: LMPanelDataState;
  @Input() panelId: string;
  @Input() isPanelNavigation = false;

  @Input() set url(url) {
    this._url = url;
    this.compileURLMessageRule();
  }

  @Input() activated: boolean;

  @Output() formPanelContentLoaded = new EventEmitter<any>();
  @Output() contentModified = new EventEmitter<any>();
  @Output() panelTransactionEvent = new EventEmitter<LMPanelTransactionEvent>();

  get url(): LMMessageRule {
    return this._url;
  }

  private _fromDataView: LMDataView;
  private _url: LMMessageRule;
  public formattedUrl: string;
  public testVersion1: boolean;
  public hasError = false;
  public errorTitle = Soho.Locale.translate('URLMissingMessageTitle');
  public errorMsg = Soho.Locale.translate('URLMissingMessage');

  constructor(
    private elementRef: ElementRef,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmContextService: LMContextService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmUrlUtilService: LMUrlUtilService,
  ) {}

  ngOnInit() {
    this.testVersion1 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1;
  }

  public getFromDataView(): LMDataView {
    return this._fromDataView;
  }

  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.htmlDocComponent.url = this.formattedUrl;

      observer.next(true);
      observer.complete();
    });
  }

  public save(callBack: Observer<boolean>) {
    if (this.htmlDocComponent) {
      this.htmlDocComponent.runSave().subscribe((result: LMUrlDocSaveResult) => {
        if (result.isComplete) {
          if (result.hasMessage) {
            this.lmGlobalUtilService.displayToastMessage('', result.message, result.isComplete ? AppConstants.TRA_ACTION_COMPLETED : AppConstants.TRA_ACTION_FAILED);
          }
          callBack.next(!result.isError);
          callBack.complete();
        }
      });
    } else {
      callBack.next(true);
      callBack.complete();
    }
  }

  public getPanelHeight(): number {
    if (this.elementRef) {
      return this.elementRef.nativeElement.offsetHeight;
    }
    return 0;
  }

  public fireFormActionComplete(status: LMActionFormDialogResultCode, data: LMActionFormCompleteData) {
    this.htmlDocComponent.fireFormActionComplete(status, data);
  }

  public isDirty(): boolean {
    return this.htmlDocComponent ?  this.htmlDocComponent.isModified() : false;
  }

  onLandmarkApiLoaded(event: any) {
  }

  onLandmarkCustomReady(event: any) {
    if (this.htmlDocComponent) {
      this.htmlDocComponent.setDataView(this._fromDataView);
    }
  }

  onNotifyUrlTransactionComplete(event: LMListTransactionEvent) {
    const panelEvent: LMPanelTransactionEvent = new LMPanelTransactionEvent(this.panelId);
    this.panelTransactionEvent.emit(panelEvent);
  }

  saveCompositeComponentState(): void {
    // no-op
  }

  clearCompositeComponentState(): void {
    // no-op
  }

  private compileURLMessageRule() {
    if (this.url) {
      if (this.url.variables && this.url.variables.length > 0 && !this._fromDataView) {
        return;
      }
      let stageUrl = this.lmFormatUtilService.formatMessageRule(this.url, this._fromDataView);
      if (stageUrl.length <= 0) {
        this.hasError = true;
        return;
      } else {
        this.hasError = false;
      }
      // append context session keys to the url.
      stageUrl = this.lmUrlUtilService.updateUrlParams(stageUrl, this.lmContextService.getContext().contextSessionKeys);

      if (stageUrl !== this.formattedUrl) {
        this.formattedUrl = stageUrl;
      }
    }
  }
}
